import { join, lensIndex, match, over, pathOr, pipe, toUpper } from 'ramda';

export default pipe(
  match(/^.*\/(.*)-cotizacion/),
  pathOr('', [1]),
  over(lensIndex(0), toUpper),
  join('')
);
